import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato llega?',
  answer: 'PDF descargable. Inmediato después del pago. Lo abrís en el celu, la tablet o la compu. También lo podés imprimir completo o por tomos.'
}, {
  question: '¿Necesito saber algo de asado para empezar?',
  answer: 'Cero. Está diseñado tanto para el que nunca encendió una parrilla solo como para el que lleva años haciéndolo. El Tomo 0 te dice exactamente por dónde arrancar según tu situación.'
}, {
  question: '¿Funciona para parrillera chica o de departamento?',
  answer: 'Sí. El sistema enseña principios, no equipamiento específico. Funciona para parrillera de obra, portátil, kettle y eléctrica.'
}, {
  question: '¿Los cortes se consiguen en cualquier carnicería?',
  answer: 'Sí. Todo lo que está en el sistema se consigue en cualquier carnicería de Argentina. Sin ingredientes raros ni cortes de importación.'
}, {
  question: '¿Sirve si ya sé hacer asados?',
  answer: 'Sí, especialmente para vos. Hacer consciente lo que hacías por costumbre es lo que convierte un buen asador en uno extraordinario.'
}, {
  question: '¿Se actualiza?',
  answer: 'Sí. Las actualizaciones son gratuitas para siempre para los que ya compraron.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-zinc-900 border-t border-zinc-800" data-id="element-69">
      <div className="container mx-auto px-4" data-id="element-70">
        <div className="max-w-3xl mx-auto" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-white mb-12" data-id="element-72">
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-4" data-id="element-73">
            {faqs.map((faq, index) => <div key={index} className={`border rounded-xl overflow-hidden transition-colors duration-200 ${openIndex === index ? 'border-amber-500/50 bg-zinc-950' : 'border-zinc-800 bg-zinc-900 hover:bg-zinc-800/50'}`} data-id="element-74">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-75">
                  <span className={`font-bold pr-4 ${openIndex === index ? 'text-amber-400' : 'text-zinc-200'}`} data-id="element-76">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'transform rotate-180 text-amber-500' : 'text-zinc-500'}`} data-id="element-77" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-78">
                  <p className="text-zinc-400 leading-relaxed" data-id="element-79">{faq.answer}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}